module.exports = __webpack_public_path__ + "img/20.9e1ac015.jpg";